import { CreateMUIStyled, styled as baseStyled } from "@mui/material";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";

export const styled = baseStyled as CreateMUIStyled<SenecEkpTheme>;
